import { Dialog } from 'primereact/dialog'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingIndicator from '../../LoadingIndicator'
import { resolveMismatch } from '../../../services/csnDashboardService'
import getPrincipal from '../../../utils/getPrincipal'
import getPLACIUser from '../../../utils/getPLACIUser'
import warningIcon from '../../../assets/images/warning_filled.svg'
import { PrimaryButton, SecondaryButton } from '../../../common/Buttons'
import './resolve-missing-hawb-popup.scss'


const ResolveMismatchPopup = ({
	resolveMismatchPopup,
	setResolveMismatchPopup ,
	flightData,
	setShowLoader,
	setAlertMessage,
	setStatus,
}) => {
	const { t } = useTranslation(['labels'])
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		console.log('flightData', flightData);
	}, [flightData])


	const handleNo = () => {
		setResolveMismatchPopup({
			isOpen: false,
			awbNumber: null
		})
	}

	const handleYes = async () => {

		try {
			setShowLoader(true)
			const principal = getPrincipal()
			const placiUser = getPLACIUser()

			const reqObj = {
				userId:  principal?.sub,
				userStation: placiUser?.stationCode ? placiUser?.stationCode : null,
				awbNumber: resolveMismatchPopup.awbNumber,
				flightId: flightData.flightId,
				userType: principal?.type,

			}
			console.log('reqObj', reqObj);
			const response = await resolveMismatch(reqObj)
			console.log('response', response);
			if (response && response.status === 200) {
				setAlertMessage(`MAWB HAWB Mismatch resolved for AWB - ${resolveMismatchPopup.awbNumber}.`)
				setStatus(true)
			} else {
				setAlertMessage(`MAWB HAWB Mismatch could not be resolved for AWB - ${resolveMismatchPopup.awbNumber}.`)
				setStatus(false)
			}
		} catch (error) {
			console.log(error)
			setAlertMessage(`MAWB HAWB Mismatch could not be resolved for AWB - ${resolveMismatchPopup.awbNumber}.`)
			setStatus(false)
		} finally {
			setShowLoader(false)
			setResolveMismatchPopup({
				isOpen: false,
				awbNumber: null
			})
			window.scrollTo(0, 0)
		}

	}

	const RenderFooter = () => {
		return (
			<div className='footer'>
                <SecondaryButton label={t('COMMON.YES')} onClick={handleYes} />
                <PrimaryButton label={t('COMMON.NO')} onClick={handleNo} />
            </div>
		)
	}

	return (
		<div className='cargo-portal-container dialog-container resolve-missing-hawb-dialog'>
			<div className='portal-dialog p-fluid'>
				<Dialog
					footer={<RenderFooter />}
					visible
					modal
					closable={true}
					header=''
					onHide={handleNo}
				>
					<div className='warning-icon-container'>
						<img src={warningIcon} alt='Warning' />
					</div>
					<h3 className='mt-1 mb-4 dialog-header'>Resolve Mismatch?</h3>
					<div className='inner-container'>
						<p className='mt-2 dialog-message'>
							Do you want to resolve the Mismatch for the MAWB - {resolveMismatchPopup.awbNumber}?
						</p>
					</div>
				</Dialog>
			</div>
			{isLoading && <LoadingIndicator />}
		</div>
	)
}

export default ResolveMismatchPopup
